/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */
import { MsalInterceptorConfiguration } from "@azure/msal-angular";
import { BrowserCacheLocation, Configuration, InteractionType, PopupRequest } from "@azure/msal-browser";

 export const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

 /**
  * Enter here the user flows and custom policies for your B2C application,
  * To learn more about user flows, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
  * To learn more about custom policies, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
  */
 export const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1_wisium',
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://wisiumprd.b2clogin.com/wisiumprd.onmicrosoft.com/B2C_1_wisium'
        },
    },
    authorityDomain: 'wisiumprd.b2clogin.com',
 };

 /**
  * Configuration object to be passed to MSAL instance on creation.
  * For a full list of MSAL.js configuration parameters, visit:
  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
  */
  export const msalConfig : Configuration = {
     auth: {
         clientId: '1abde77e-46dc-4e4c-b63f-b3a2676f13fe', // Wisium MatrixNutri
         authority: b2cPolicies.authorities.signUpSignIn.authority,
         knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
         redirectUri: 'https://equadvice.wisium.com/user/auth', // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
         postLogoutRedirectUri: 'https://equadvice.wisium.com/user/login', // Indicates the page to navigate after logout.
         navigateToLoginRequestUrl: true // If "true", will navigate back to the original request location before processing the auth code response.
     },
     cache: {
         cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
         storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
     },
     system: {
     }
 };

 /**
 * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters,
 * visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_authenticationparameters_.html
 */
 export const loginRequest: PopupRequest = {
    scopes: ['openid', 'profile', 'https://wisiumprd.onmicrosoft.com/524da507-1acf-42a6-bbd9-52261d1a5054/Api.Access'],
};

export const SHARED_AZURE_PROTECTED_SCOPE = 'https://wisiumprd.onmicrosoft.com/4eb4e1a0-2c5d-4455-8586-b64f5a88ab3d/Api.Access';

export const msalInterceptorConfig : MsalInterceptorConfiguration = {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
        ['services/api', [SHARED_AZURE_PROTECTED_SCOPE]],
        ['api', ['https://wisiumprd.onmicrosoft.com/524da507-1acf-42a6-bbd9-52261d1a5054/Api.Access']],
        ['/public/i18n', null],
        ['assets', null],
        ['https://www.googletagmanager.com/', null],
        ['https://www.google-analytics.com/', null],
        ['https://cdn.cookielaw.org/', null],
    ])
};
